import React, { useRef } from 'react';

const RevibeMembership = () => {
  const scrollRef = useRef(null);

  const benefits = [
    {
      id: 1,
      title: "Daily Hand Holding",
      description: "We assign a clinical Dietician as your Client Success Manager to keep you on track every single day.",
      image: "https://picsum.photos/seed/guidance/600/400",
      icon: (
        <svg className="w-5 h-5 text-lime-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
    },
    {
      id: 2,
      title: "Clinical Dieticians",
      description: "Real in-depth assessment & personalised weight management tailored to your body and goals.",
      image: "https://picsum.photos/seed/diet/600/400",
      icon: (
        <svg className="w-5 h-5 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
    },
    {
      id: 3,
      title: "Live & Recorded Workouts",
      description: "Yoga, Cardio, Strength Training — do what you enjoy most.",
      image: "https://picsum.photos/seed/travel/600/400",
      icon: (
        <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      id: 4,
      title: "Expert Trainers",
      description: "Certified coaches guiding you step by step through every movement.",
      image: "https://picsum.photos/seed/community/600/400",
      icon: (
        <svg className="w-5 h-5 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
    },
    {
      id: 5,
      title: "Anytime. Anywhere.",
      description: "From your living room or while traveling.",
      image: "https://picsum.photos/seed/workout/600/400",
      icon: (
        <svg className="w-5 h-5 text-pink-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
    },
    {
      id: 6,
      title: "Community Support",
      description: "Connect with others who are on the same journey to share and grow.",
      image: "https://picsum.photos/seed/trainer/600/400",
      icon: (
        <svg className="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="bg-gray-100 px-6 py-12">

      {/* Header */}
      <div className="mb-8">
        <span className="text-lime-500 font-bold tracking-widest text-sm uppercase">
          Revibe Membership
        </span>
        <h1 className="text-4xl font-bold mt-3 mb-3 text-black leading-tight">
          Exclusive <br />
          <span className="text-lime-400">Benefits</span>
        </h1>
        <p className="text-gray-400 text-base">
          Everything tailored for your health goals — all in one place.
        </p>
      </div>

      {/* Carousel — no arrows, no dots, drag/swipe to scroll */}
      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto pb-4"
        style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch',
          scrollSnapType: 'x mandatory',
          cursor: 'grab',
        }}
        onMouseDown={(e) => {
          const el = scrollRef.current;
          el.style.cursor = 'grabbing';
          const startX = e.pageX - el.offsetLeft;
          const scrollLeft = el.scrollLeft;
          const onMove = (ev) => {
            const x = ev.pageX - el.offsetLeft;
            el.scrollLeft = scrollLeft - (x - startX);
          };
          const onUp = () => {
            el.style.cursor = 'grab';
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
          };
          window.addEventListener('mousemove', onMove);
          window.addEventListener('mouseup', onUp);
        }}
      >
        {benefits.map((benefit) => (
          <div
            key={benefit.id}
            className="flex-shrink-0 bg-[#1a1c1e] rounded-2xl overflow-hidden flex flex-col border border-gray-800 transition-transform hover:scale-[1.02]"
            style={{ width: '220px', scrollSnapAlign: 'start' }}
          >
            {/* Image */}
            <div className="relative h-36">
              <img
                src={benefit.image}
                alt={benefit.title}
                className="w-full h-full object-cover opacity-80"
                draggable={false}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a1c1e] via-transparent to-transparent" />
            </div>

            {/* Content */}
            <div className="p-4 pt-3">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-gray-800 p-2 rounded-xl shrink-0">
                  {benefit.icon}
                </div>
                <h3 className="text-sm font-bold text-white leading-tight">{benefit.title}</h3>
              </div>
              <p className="text-gray-500 text-xs leading-relaxed">{benefit.description}</p>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default RevibeMembership;